var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 1.1697C10.8128 0.983448 10.5594 0.878906 10.2952 0.878906C10.031 0.878906 9.77756 0.983448 9.59019 1.1697L6.00019 4.7097L2.46019 1.1697C2.27283 0.983448 2.01938 0.878906 1.75519 0.878906C1.49101 0.878906 1.23756 0.983448 1.05019 1.1697C0.956464 1.26266 0.88207 1.37326 0.831301 1.49512C0.780533 1.61698 0.754395 1.74769 0.754395 1.8797C0.754395 2.01171 0.780533 2.14242 0.831301 2.26428C0.88207 2.38613 0.956464 2.49674 1.05019 2.5897L5.29019 6.8297C5.38316 6.92343 5.49376 6.99782 5.61562 7.04859C5.73747 7.09936 5.86818 7.1255 6.00019 7.1255C6.1322 7.1255 6.26291 7.09936 6.38477 7.04859C6.50663 6.99782 6.61723 6.92343 6.71019 6.8297L11.0002 2.5897C11.0939 2.49674 11.1683 2.38613 11.2191 2.26428C11.2699 2.14242 11.296 2.01171 11.296 1.8797C11.296 1.74769 11.2699 1.61698 11.2191 1.49512C11.1683 1.37326 11.0939 1.26266 11.0002 1.1697Z",
    fill: "#075244"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.874d9629328d7be60bf47861507522d1.svg";
export { ForwardRef as ReactComponent };